import React from "react";
import { Form, InputGroup } from "react-bootstrap";

function SearchField({ placeholder, handleChange, handleSubmit }) {
  return (
    <div className="search-form">
      <Form.Group>
        <InputGroup>
          <Form.Control
            type="search"
            placeholder={placeholder}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid"></Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
    </div>
  );
}

export default SearchField;
